import React from 'react';
import { RBHBox, RBHText } from '../../../../shared/components';
import { ArrowSwitch } from '../../../../shared/resources/image/svg/main/arrow-switch';
import { Colors } from '../../../../shared/theme';
import styles from './styles';

interface SortButtonProps {
	textId: string;
	onClick: () => void;
	id?: string;
	disable?: boolean;
}
export const SortButton = ({ textId, onClick, disable, id }: SortButtonProps) => {
	const color = disable ? Colors.grey400 : Colors.violet;
	const cursor = disable ? styles.notAllowed : styles.pointer

	const handleClick = () => {
		if (!disable) {
			onClick();
		}
	};
	return (
		<RBHBox id={id} style={{ ...styles.sortingSection, ...cursor }} onClick={handleClick}>
			<ArrowSwitch fill={color} />
			<RBHText text={textId} style={{ color }}></RBHText>
		</RBHBox>
	);
};
